import ApplicationController from './application_controller'

// The period, the incident scope and the compared auction houses feed the SLA
// and SLO frames and nothing else on the Organization page, so applying them
// refetches those two frames instead of reloading the whole document.
//
// The address bar follows with the same query, so a reload and a shared link
// still restore the comparison. A frame-only change without it drifts from the
// page URL: dropping a house left it in the address bar and a reload brought it
// back, which is why this used to navigate the page.
//
// Replaced, not pushed: Turbo restores only the history entries it made itself,
// so a pushed entry would let Back change the URL under frames that stay put.
export default class extends ApplicationController {
  static targets = ['frame']

  // `add_owner_id` is the picker's field. Folded into the compared list here,
  // so the frames and the address bar receive the settled selection rather
  // than an instruction to add that the next reload would replay.
  apply (event) {
    event.preventDefault()
    const params = new URLSearchParams(new FormData(event.target))
    const added = params.get('add_owner_id')
    params.delete('add_owner_id')
    if (added) params.append('owner_ids[]', added)
    this.refresh(params)
  }

  // The link already carries the remaining selection, built by the server.
  remove (event) {
    event.preventDefault()
    this.refresh(new URL(event.currentTarget.href).searchParams)
  }

  // The status is the SLO block's own filter and its form refreshes that frame
  // alone. The address bar is its one source: the SLA filters, a comparison
  // change and a reload read the orders through it, and a Remove link, built
  // before the reader changed the status, cannot bring an old one back.
  keepStatus (event) {
    const url = new URL(location.href)
    url.searchParams.delete('status')
    const status = new FormData(event.target).get('status')
    if (status) url.searchParams.append('status', status)
    history.replaceState(history.state, '', url)
  }

  refresh (params) {
    const status = new URLSearchParams(location.search).get('status')
    params.delete('status')
    if (status) params.append('status', status)
    history.replaceState(history.state, '', `${location.pathname}?${params}`)
    this.frameTargets.forEach((frame) => {
      const url = new URL(frame.src, location.href)
      url.search = params
      frame.src = url
    })
  }
}
